import React, { useEffect } from 'react';

const AlertModal = ({ message, info, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 3000); // Auto-close after 3 seconds
    return () => clearTimeout(timer);
  }, [onClose]);

  return (
 <div className="fixed inset-0 p-4 sm:p-6 bg-black bg-opacity-60 flex items-center justify-center z-20">
    <div className="bg-yellow relative backdrop-blur-md rounded-xl w-full max-w-full sm:max-w-xl p-6 sm:p-8 shadow-xl transition-all duration-300 animate-fade-in text-black">

        <div className="flex justify-end">
          <button
            onClick={onClose}
              className="relative w-10 h-10 flex items-center text-center justify-center text-3xl
                rounded-full bg-[#FF1111] shadow-[0_6px_0_#C30F0F] text-[#FFCC21] font-extrabold
                active:translate-y-[2px] active:shadow-none
                transition-all duration-200 ease-in-out
                hover:scale-[1.03]
                hover:brightness-110"
            >
            ✕
          </button>
        </div>
        
        <h2 className="text-xl font-semibold text-center mb-2">{info}</h2>
        <p className="font-bold text-center mb-4">{message}</p>
      </div>
    </div>
  );
};

export default AlertModal;


